import React from 'react'
import { get as getConfig } from '../../config/index'
import { useIsDivinationCohort } from './useIsDivinationCohort'
import * as OracleModule from './PromotionGaiaOracle'
import * as DivinationModule from './PromotionGaiaDivination'

export type PromotionGaiaOracleGateProps = Record<string, unknown>

/**
 * Inner gate that calls the cohort hook. Only rendered when the Gaia
 * `features.ai.divination` flag is ON — this keeps the hook out of the
 * render tree entirely when the FF killswitch is off.
 */
const PromotionGaiaOracleGateInner = (props: PromotionGaiaOracleGateProps) => {
  const { isDivinationCohort } = useIsDivinationCohort()

  if (isDivinationCohort) {
    const PromotionGaiaDivination = DivinationModule.default
    return <PromotionGaiaDivination {...props} />
  }

  const PromotionGaiaOracle = OracleModule.default
  return <PromotionGaiaOracle {...props} />
}

export const PromotionGaiaOracleGate = (props: PromotionGaiaOracleGateProps) => {
  const divinationEnabled = Boolean(getConfig().features.ai.divination)

  if (!divinationEnabled) {
    const PromotionGaiaOracle = OracleModule.default
    return <PromotionGaiaOracle {...props} />
  }

  return <PromotionGaiaOracleGateInner {...props} />
}
